import { BarChart3, CircleDot, Columns3, LayoutGrid, MessageSquare, Quote, Scale, SlidersHorizontal, type LucideIcon } from "lucide-react";
import type { StageViewDef, StageViewKey } from "../../lib/stageViews";

const ICONS: Record<StageViewKey, LucideIcon> = {
  bars: BarChart3,
  dots: CircleDot,
  compare: Columns3,
  scale: Scale,
  distribution: BarChart3,
  sentiment: SlidersHorizontal,
  themes: LayoutGrid,
  voices: MessageSquare,
  quotes: Quote,
};

/** Facilitator-only pill row under the question title. Anonymous viewers never
 *  mount this, so the projector stays identical. Digit keys 1–3 mirror it. */
export default function StageViewSwitcher({ views, activeKey, onSelect, busy }: { views: StageViewDef[]; activeKey: StageViewKey; onSelect: (key: StageViewKey) => void; busy: boolean }) {
  return (
    <div role="radiogroup" aria-label="Ansicht auf der Bühne" className="inline-flex items-center gap-1 mt-4 p-1 rounded-pill bg-rc-paper/[0.06] border border-rc-paper/10">
      {views.map((v, i) => {
        const Icon = ICONS[v.key];
        const active = v.key === activeKey;
        return (
          <button
            key={v.key}
            type="button"
            role="radio"
            aria-checked={active}
            disabled={busy}
            onClick={() => onSelect(v.key)}
            title={`${v.label} (Taste ${i + 1})`}
            className={`inline-flex items-center gap-2 rounded-pill px-3.5 py-1.5 text-[12px] font-semibold tracking-wide transition-colors ${
              active ? "bg-rc-paper text-rc-black shadow-hard-lime" : "text-rc-paper/70 hover:text-rc-paper hover:bg-rc-paper/10"
            } disabled:cursor-wait`}
          >
            <Icon className="w-3.5 h-3.5" />
            {v.label}
          </button>
        );
      })}
    </div>
  );
}
